import { call, put, takeLatest } from 'redux-saga/effects';
import { extractErrorMessage } from '~/helpers/util/extractErrorMessage';
import { Action } from '~/helpers/util/reducers';
import { EditInit } from '~/store/modules/_core/specialDates/duck';
import * as SpecialDateService from '~/store/modules/_core/specialDates/service';
import { actions, Types } from './duck';

export function* editSaga(action: Action<EditInit>) {
  try {
    const data = action.payload;
    yield call(SpecialDateService.edit, data);
    yield put(actions.editSuccess());
  } catch (error) {
    const errorMessage = extractErrorMessage(error);
    yield put(actions.editFailure({ errorMessage }));
  }
}

export default [takeLatest(Types.EDIT_INIT, editSaga)];
